import React from "react";

import { Card } from "../../design-system";

import * as styles from "./Stories.module.scss";
import { CUSTOMER_DATA } from "../../../data/pages";

const Stories: React.FC = () => {
  return (
    <section className={styles.Stories}>
      <div className={styles.Stories_container}>
        <header className={styles.Stories_header}>
          <h2 className={styles.Stories_header_title}>
            Building the new standard in business payments
          </h2>
          <p>
            We serve thousands of businesses and some of them have shared
            stories of their experience on Brass.
          </p>
        </header>

        <div className={styles.Stories_content}>
          {CUSTOMER_DATA.STORIES.map((story, index) => (
            <Card key={index} customStyles={styles.Stories_card}>
              <div>
                <div className={styles.Stories_card_logo}>
                  <img src={story.image} alt={story.logo} />
                </div>
                <p className={styles.Stories_card_text}>“{story.story}“</p>
              </div>
              <div className={styles.Stories_card_meta}>
                <div className={styles.Stories_card_avatar}>
                  <img src={story.profile} alt="" />
                </div>
                <div>
                  <h3 className={styles.Stories_card_title}>{story.name}</h3>
                  <p className={styles.Stories_card_role}>{story.title}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stories;
